var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({attrs:{"data-twic-src":_vm.twicSrc,"src":_vm.preview,"data-twic-src-focus":"auto"}},'img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }